import React from 'react';
import PropTypes from 'prop-types';

const VVEGuestConsent = ({ consentVerbiageList }) => {
  return (
    <>
      {consentVerbiageList.map((content, index) => (
        <li key={`abridge-${index}`} className={index === consentVerbiageList.length - 1 ? 'vve-guest-last-item' : ''}>
          {content}
        </li>
      ))}
    </>
  );
};

VVEGuestConsent.propTypes = {
  consentVerbiageList: PropTypes.array.isRequired
};

export default VVEGuestConsent;
